"use client";

import { useState } from "react";
import { AppleIcon } from "@/features/signup/ui/icons/AppleIcon";
import { GoogleIcon } from "@/features/signup/ui/icons/GoogleIcon";
import { initiateOktaSocialLogin } from "@/shared/lib/auth/oktaSocial";

export function SocialSignIn() {
  const [error, setError] = useState<string | null>(null);

  async function handleOktaLogin(provider: "google" | "apple") {
    setError(null);
    const idpId =
      provider === "google"
        ? (process.env.NEXT_PUBLIC_OKTA_GOOGLE_IDP_ID ?? "")
        : (process.env.NEXT_PUBLIC_OKTA_APPLE_IDP_ID ?? "");
    try {
      await initiateOktaSocialLogin(
        provider,
        idpId,
        `${window.location.origin}/auth/okta-callback`,
      );
    } catch {
      setError("Sign-in failed. Please try again.");
    }
  }

  return (
    <div className="space-y-3 mt-4">
      <div className="relative flex items-center">
        <div className="flex-1 border-t border-border" />
        <span className="mx-3 text-xs text-secondary-foreground">
          or continue with
        </span>
        <div className="flex-1 border-t border-border" />
      </div>

      <div className="space-y-2.5">
        <button
          type="button"
          onClick={() => handleOktaLogin("google")}
          className="w-full flex items-center justify-center gap-2.5 px-4 py-2.5 border border-border rounded text-sm font-medium text-foreground bg-inverse-foreground hover:bg-muted transition-colors cursor-pointer"
        >
          <GoogleIcon />
          Sign in with Google
        </button>

        <button
          type="button"
          onClick={() => handleOktaLogin("apple")}
          className="w-full flex items-center justify-center gap-2.5 px-4 py-2.5 border border-border rounded text-sm font-medium text-foreground bg-inverse-foreground hover:bg-muted transition-colors cursor-pointer"
        >
          <AppleIcon />
          Sign in with Apple
        </button>

        {error && (
          <p className="text-sm text-destructive text-center">{error}</p>
        )}
      </div>
    </div>
  );
}
